// How far the frame is allowed to extend beyond the card box on every side.
// Kept equal across all frames so the card can reserve a fixed bleed margin.
export const BLEED = 12;

// A concave 4-point sparkle centred at (cx,cy) with tip radius s.
function sparkPath(cx, cy, s) {
  const k = s * 0.16;
  return `M ${cx} ${cy - s}`
    + ` C ${cx} ${cy - k} ${cx + k} ${cy} ${cx + s} ${cy}`
    + ` C ${cx + k} ${cy} ${cx} ${cy + k} ${cx} ${cy + s}`
    + ` C ${cx} ${cy + k} ${cx - k} ${cy} ${cx - s} ${cy}`
    + ` C ${cx - k} ${cy} ${cx} ${cy - k} ${cx} ${cy - s} Z`;
}

// Magenta neon outline. Glow is faked with three stacked strokes of
// decreasing width/increasing opacity (matching the app frame, no blur
// filter), plus sparkle accents at the corners and mid-edges.
export default function PinkNeonFrame({ w, h, radius = 12 }) {
  const W = w + BLEED * 2;
  const H = h + BLEED * 2;
  const x = BLEED;
  const y = BLEED;
  const r = radius + 2;
  const corners = [[x, y], [x + w, y], [x, y + h], [x + w, y + h]];
  return (
    <div style={{ position: 'absolute', top: -BLEED, left: -BLEED, width: W, height: H, pointerEvents: 'none' }}>
      <svg width={W} height={H} xmlns="http://www.w3.org/2000/svg">
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="#ff2ee6" strokeWidth={7} opacity={0.14} />
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="#ff52ef" strokeWidth={3.5} opacity={0.45} />
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="#ffb3f6" strokeWidth={1.5} opacity={0.95} />
        {corners.map(([cx, cy], i) => (
          <path key={i} d={sparkPath(cx, cy, 7)} fill="#ffffff" opacity={0.92} />
        ))}
        <path d={sparkPath(x + w / 2, y, 5)} fill="#ffd9fb" opacity={0.8} />
        <path d={sparkPath(x + w / 2, y + h, 5)} fill="#ffd9fb" opacity={0.8} />
      </svg>
    </div>
  );
}
